import React from "react";
import Lottie from "lottie-react";
import development from "../../assets/animation/development.json";

const InDevelopment = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen h-screen">
      <div className="w-[300px] sm:w-[400px]">
        <Lottie animationData={development} loop={true} />
      </div>
      <h1 className="text-2xl font-bold text-gray-700 mt-4">This Page is Under Development 🚧</h1>
      <p className="text-gray-500 mt-2 text-center max-w-md">
        We're working hard to bring this feature to you soon. Stay tuned!
      </p>
    </div>
  );
};

export default InDevelopment;
